export default {
  'pages.login.success': '登录成功！',
  'pages.login.username.required': '用户名是必填项！',
  'pages.login.password.required': '密码是必填项！',
  // 登录页面
  'login.welcomeBack': '欢迎回来',
  'login.welcomeSubtitle': '登录以访问您的账户',
  'login.copyright': '保留所有权利',
  'login.signIn': '登录',
  'login.signInSubtitle': '请输入您的账户信息',
  'login.username': '用户名',
  'login.usernamePlaceholder': '请输入用户名',
  'login.password': '密码',
  'login.passwordPlaceholder': '请输入密码',
  'login.loginToDashboard': '登录到仪表板',
  // 404
  'pages.404.subTitle': '抱歉，您访问的页面不存在。',
  'pages.404.buttonText': '返回首页',
  // 占位页面
  'pages.placeholder.title': '页面标题',
  'pages.placeholder.content': '页面内容',
};
